import React, { FC } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import ActionButtonsContainer from '../../actionButtons/ActionButtonsContainer';
import Grid from '@material-ui/core/Grid';
import actionButtonsStyles from '../../../presentational/actionButtons/ActionButtonsStyles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import clsx from 'clsx';

export interface IActionButtonsGridElementProps {
  disabled: boolean;
}

const ActionButtonsGridElement: FC<IActionButtonsGridElementProps> = ({ disabled }) => {
  const styles = actionButtonsStyles();
  const {
    breakpoints,
    spc: {
      customise: { footer },
    },
  } = useTheme<ISpcTheme>();
  const isGridElementVisible = !useMediaQuery(breakpoints.down('sm')) || footer?.displayCheckoutButtons;

  if (!isGridElementVisible) {
    return null;
  }

  return (
    <Grid item={true} lg={4} md={2} sm={12} className={clsx(styles.container, styles.gridContainer)}>
      <Box className={styles.buttonsWrapper}>
        <ActionButtonsContainer disabled={disabled} />
      </Box>
    </Grid>
  );
};

export default ActionButtonsGridElement;
